import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/crown-icon-with-background.svg")